import { render, staticRenderFns } from "./DuelsGamesElement.vue?vue&type=template&id=62809aad&scoped=true"
import script from "./DuelsGamesElement.vue?vue&type=script&lang=js"
export * from "./DuelsGamesElement.vue?vue&type=script&lang=js"
import style0 from "./DuelsGamesElement.vue?vue&type=style&index=0&id=62809aad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62809aad",
  null
  
)

export default component.exports